export default __webpack_public_path__ + "static/media/joinMinority.ce1e3a7a.png";